<!-- 质量管理 面板 -->
<template>
  <div>
    <div class="panel-wrapper">
      <BorderTitle>{{config.title}}</BorderTitle>
      <div class="panel-content">
        <div class="left">
          <template v-for="cfg in config.circleConfig">
            <EquipMeter v-if="cfg.title=='速度'||cfg.title=='发动机转速'" :key="cfg.id" v-bind="cfg" />
            <EquipCircle v-else :key="cfg.id" v-bind="cfg" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipCircle from "./circle2";
import EquipMeter from "./circle3";
import BorderTitle from "../common/borderTitle";
export default {
  props: ["config","isTanpuji"],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  components: {
    BorderTitle,
    EquipCircle,
    EquipMeter
  },
};
</script>

<style lang="scss" scoped="">
.panel-wrapper {
  background: #fff;
  padding: 18px;
}
.panel-content {
  height: 164px;
  display: flex;
  .left {
    // width: 660px;
    height: 100%;
    display: flex;
    flex: 1;
    justify-content: space-around;
    align-items: center;
    padding-top: 30px;
  }
}
</style>